import { Polygon, MultiPolygon, MultiLineString } from 'geojson';

export enum FilterTypes {
  DESCRIPTION = 'description',
  SEARCH = 'search',
}

export type FiltersState = {
  [FilterTypes.DESCRIPTION]: string;
  [FilterTypes.SEARCH]: string;
};

export interface SelectedFeature {
  id: string | number;
  segments: MultiLineString;
  source: string;
  sourceLayer: string;
  name?: string;
  coverage?: number;
}

export interface ISelectionPayload {
  polygon: Polygon | MultiPolygon;
  segments: MultiLineString;
  isContiguous?: boolean;
}
